import { KnowledgeEntry } from "../types";
import { KnowledgeEntryCard } from "../KnowledgeEntryCard";

interface EntriesListProps {
  entries: KnowledgeEntry[];
  onView: (entry: KnowledgeEntry) => void;
  onDelete: (entry: KnowledgeEntry) => void;
}

export function EntriesList({ entries, onView, onDelete }: EntriesListProps) {
  if (entries.length === 0) {
    return (
      <div className="text-center text-gray-500">No entries found</div>
    );
  }

  return (
    <div className="space-y-4">
      {entries.map((entry) => (
        <KnowledgeEntryCard
          key={entry.id}
          entry={entry}
          onView={onView}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
